import React, { useState } from 'react'
import jwtDecode from 'jwt-decode'
import { ErrorBillBoard, LaunchOAuth, LtiHeightLimit, LtiTokenRetriever, LtiApplyTheme } from '@oxctl/ui-lti'
import Home from './pages/home/Home'
import { connect } from 'react-redux'
import { promptUserLogin, setJwtToken, setServer } from './actions/userAccess'
import { setCourse } from './actions/canvas.js'

const App = ({ setCourse, server, setServer, setJwtToken, jwtToken ,promptLogin, promptUserLogin }) => {
  const [comInstructureBrandConfigJsonUrl, setComInstructureBrandConfigJsonUrl] = useState(null)
  const [loading, setLoading] = useState(true)
  const [canvasUserPrefersHighContrast, setCanvasUserPrefersHighContrast] = useState(null)
  const [messages, setMessages] = useState(null)

  const updateToken = (token, toolServer) => {
    setJwtToken(token)
    setServer(toolServer)
    const jwt = jwtDecode(token)

    if (jwt) {
      const course = {
        id: parseInt(jwt['https://purl.imsglobal.org/spec/lti/claim/custom'].canvas_course_id),
        name: jwt['https://purl.imsglobal.org/spec/lti/claim/custom'].canvas_course_name
      }

      const account = {
        id: parseInt(jwt['https://purl.imsglobal.org/spec/lti/claim/custom'].canvas_account_id)
      }

      setCourse(course)

      setComInstructureBrandConfigJsonUrl(jwt['https://purl.imsglobal.org/spec/lti/claim/custom'].com_instructure_brand_config_json_url)
      setCanvasUserPrefersHighContrast(jwt['https://purl.imsglobal.org/spec/lti/claim/custom'].canvas_user_prefers_high_contrast === "true")
    } else {
      setMessages("Failed to decode token")
    }
    setLoading(false)
    
  }

  return (
    <ErrorBillBoard message={messages}>
      <LtiApplyTheme url={comInstructureBrandConfigJsonUrl} highContrast={canvasUserPrefersHighContrast}>
        <LtiTokenRetriever handleJwt={updateToken}>
          <LaunchOAuth accessToken={jwtToken} server={{proxyServer: server}} promptLogin={promptLogin}
                       promptUserLogin={() => promptUserLogin(false)}>
            <LtiHeightLimit>
              <Home loading={loading} />
            </LtiHeightLimit>
          </LaunchOAuth>
        </LtiTokenRetriever>
      </LtiApplyTheme>
    </ErrorBillBoard>
  )
}

const mapStateToProps = state => {
  return {
    promptLogin : state.userAccess.promptLogin,
    jwtToken: state.userAccess.jwtToken,
    server: state.userAccess.server,
  }
}

export default connect(mapStateToProps, { setCourse, setServer, setJwtToken, promptUserLogin })(App)